import React from "react";
import { Button } from "@shadcn-in-nx/ui/button";
import { Badge } from "@shadcn-in-nx/ui/badge";
import { Eye } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@shadcn-in-nx/ui/dropdown-menu";

function HiddenColumnsIndicator({ hiddenColumns, onShowColumn, onShowAll }) {
    if (hiddenColumns.size === 0) return null;

    const hiddenList = Array.from(hiddenColumns);

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" className="flex-shrink-0 gap-1">
                    <Eye className="w-4 h-4" />
                    <Badge variant="secondary">{hiddenColumns.size}</Badge>
                    <span className="hidden md:inline">hidden</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={onShowAll} className="font-medium border-b mb-1">
                    Show all columns
                </DropdownMenuItem>
                {hiddenList.map((col) => (
                    <DropdownMenuItem key={col} onClick={() => onShowColumn(col)}>
                        Show "{col}"
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

export default HiddenColumnsIndicator;
